import React from 'react';
import {bindActionCreators} from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../redux/actions'; //Import your actions
import 'materialize-css';
import Confetti from 'react-confetti';
import '../../styles/report.scss';

import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import { reportViewUrl } from '../../utils/reportUrls';

class SubmitSuccess extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      // Confetti needs real pixels; window.width/height are always undefined.
      width: typeof window === 'undefined' ? 0 : window.innerWidth,
      height: typeof window === 'undefined' ? 0 : window.innerHeight,
      copied: false,
    };
  }

  componentDidMount() {
    this.handleResize = () => this.setState({
      width: window.innerWidth,
      height: window.innerHeight,
    });
    window.addEventListener('resize', this.handleResize);

    this.handleKeyDown = (e) => {
      if (e.key === 'Escape') this.props.close();
    };
    window.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('keydown', this.handleKeyDown);
    clearTimeout(this.copyTimer);
  }

  formatSubmittedAt(submitted) {
    if (!submitted) return null;
    return new Date(submitted).toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    });
  }

  copyLink(e) {
    e.stopPropagation();
    const url = reportViewUrl(this.props.report?.hash_id) || this.props.report?.url;
    if (!url || !navigator.clipboard) return;

    navigator.clipboard.writeText(url).then(() => {
      this.setState({ copied: true });
      clearTimeout(this.copyTimer);
      this.copyTimer = setTimeout(() => this.setState({ copied: false }), 2000);
    });
  }

  render() {
    const report = this.props.report || {};
    const viewUrl = reportViewUrl(report.hash_id) || report.url;
    const submittedAt = this.formatSubmittedAt(report.submitted);
    const recipientCount = report.recipients?.length || 0;

    return (
      <div className="report-modal submit-success" onClick={() => this.props.close()}>
        <Confetti
          width={this.state.width}
          height={this.state.height}
          numberOfPieces={160}
          gravity={0.22}
          initialVelocityY={4}
          recycle={false}
        />

        <div className="submit-success-card" onClick={(e) => e.stopPropagation()}>
          <button
            type="button"
            className="submit-success-close"
            aria-label="Close"
            onClick={() => this.props.close()}
          >
            <CloseRoundedIcon />
          </button>

          <div className="submit-success-mark" aria-hidden="true">
            <CheckRoundedIcon />
          </div>

          <div className="submit-success-heading">
            <span className="submit-success-title">Report submitted</span>
            {report.title ? (
              <span className="submit-success-subtitle">{report.title}</span>
            ) : null}
          </div>

          <div className="submit-success-meta">
            {submittedAt ? (
              <span className="submit-success-meta-item">{submittedAt}</span>
            ) : null}
            {recipientCount ? (
              <span className="submit-success-meta-item">
                <PeopleAltOutlinedIcon />
                Sent to {recipientCount} {recipientCount === 1 ? 'recipient' : 'recipients'}
              </span>
            ) : null}
          </div>

          <div className="submit-success-actions">
            <a
              className="submit-success-button primary"
              href={viewUrl}
              target="_blank"
              rel="noreferrer"
            >
              <OpenInNewRoundedIcon />
              View report
            </a>

            <a className="submit-success-button" href="/reports">
              Back to dashboard
            </a>
          </div>

          {viewUrl ? (
            <button
              type="button"
              className="submit-success-copy"
              onClick={(e) => this.copyLink(e)}
            >
              <ContentCopyRoundedIcon />
              {this.state.copied ? 'Link copied' : 'Copy link'}
            </button>
          ) : null}
        </div>
      </div>
    )
  }
}

function mapStateToProps(state, props) {
  return {
    report: state.report
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SubmitSuccess);
